<template>
  <SplitContainer21 style="height:100%" :layout="12">
    <template #top>
      <TableMain ref="OrderPurchSearchTable1" name="myName" :fields="fields" :title="table_title.title1"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="false"
        :show_toolbar="false" :show_filter="true" :selectable="true"
        :hb_table_class="'hb_table_guest_vend_purch_search_class1'" :isBusy="isBusy_table1" :table_height_adjust="-10"
        :loading_width="60" @on_query="on_query" @tool_invoke="tool_invoke" @current_changed="current_changed">
        <template #query>
          <el-select v-model="dateChoose" placeholder="" size="small" style="width: 100px">
            <el-option :label="$t('common.delivery_date')" value="date1"></el-option>
            <el-option :label="$t('common.order_date')" value="date2"></el-option>
          </el-select>
          <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
            align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
            :picker-options="pickerOptions()">
          </el-date-picker>
          平台采购单号：<el-input size="small" style="width: 120px" clearable v-model="PurchId"></el-input>
          物料名称：<el-input size="small" style="width: 120px" clearable v-model="ItemId"></el-input>
        </template>
      </TableMain>
    </template>
    <template #bottom>
      <TableMain ref="OrderPurchSearchTable2" name="myName" :show_query_container="false" :fields="plan_fields"
        :title="table_title.title2" :date_picker_label="date_picker_label" :query_button_label="query_lable"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :selectable="true"
        :hb_table_class="'hb_table_guest_vend_purch_search_class2'" :isBusy="isBusy_table2" :table_height_adjust="0"
        :loading_width="100" @tool_invoke="tool_invoke">
      </TableMain>
    </template>
  </SplitContainer21>
</template>

<script>
import * as api from "@/shared/api"
// -- import * as _ from "lodash-es"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as GuestController from "../../controllers/pages/GuestController"
import * as localStorageMgr from "../../shared/localStorageMgr"
import BaseContainer from "../components/BaseContainer"
import SplitContainer21 from "../components/container/SplitContainer21"
import TableMain from "../components/table/TableMain"

export default {
  name: "GuestVendForcasetOrder",
  components: {
    TableMain,
    BaseContainer,
    Split,
    SplitContainer21,
  },
  data() {
    return {
      guest_info: null,
      tab_index: 0,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "采购订单跟踪列表",
        title2: "交货计划列表",
      },
      PurchId: "",
      ItemId: "",
      fields: GuestController.fields.purch_return_fields,
      plan_fields: GuestController.fields.plan_fields,
      isBusy_table1: false,
      isBusy_table2: false,
      dateChoose: "date2",
      date_range: []
    }
  },
  created() {
    this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },
  mounted() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
  },

  methods: {
    pickerOptions() {
      let this_ = this
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    //#region table1
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      set_data([])
      // let _fromDate = "",
      //   _toDate = "";
      let _params = {
        pub_token: this.ls.get("pub_guest_token"),
        PurchId: this.PurchId,
        ItemId: this.ItemId
      }
      if (!_.isNull(this.date_range) && this.PurchId == "" && this.ItemId == "") {
        if (this.dateChoose == "date1") {
          if (!_.isNull(this.date_range) && this.PurchId == "") {
            let _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
            let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
            _toDate = this.$date.format(
              this.$date.addDays(new Date(_toDate), 1),
              "yyyy-MM-dd"
            )
            _params.FromDate = _fromDate
            _params.ToDate = _toDate
          }
        } else {
          if (!_.isNull(this.date_range) && this.PurchId == "") {
            let _fromOrderDate = this.$date.format(
              this.date_range[0],
              "yyyy-MM-dd"
            )
            let _toOrderDate = this.$date.format(
              this.date_range[1],
              "yyyy-MM-dd"
            )
            _toOrderDate = this.$date.format(
              this.$date.addDays(new Date(_toOrderDate), 1),
              "yyyy-MM-dd"
            )
            _params.FromOrderDate = _fromOrderDate
            _params.ToOrderDate = _toOrderDate
          }
        }
      }
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_vend_purch_return_line"),
        parameters: _params,
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        set_data(_result[0].result.data.Result[0])
      }

      this.isBusy_table1 = false
    },

    tool_invoke(data) { },
    async current_changed(old, current) {
      if (_.isNull(current)) {
        return
      }
      this.isBusy_table2 = true
      this.$refs.OrderPurchSearchTable2.SetData([])
      let _params = {
        pub_token: this.ls.get("pub_guest_token"),
        PurchId: current.local_PurchId,
        LineNumber: current.LineNumber
      }
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_vend_purchase_order_delivery"),
        parameters: _params,
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        this.$refs.OrderPurchSearchTable2.SetData(_result[0].result.data.Result[0])
      }

      this.isBusy_table2 = false
    },
  },
}
</script>

<style>
.hb_table_guest_vend_purch_search_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 200rem;
}

.hb_table_guest_vend_purch_search_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
